(function (angular) {
    'use strict';

    angular.module('shared')
        /**
         *
         */
        .controller('controlsModal', ['$scope', '$uibModalInstance', 'moment', function ($scope, $uibModalInstance, moment) {

            $scope.options = {
                minDate: new Date(),
                showWeeks: false
            };

            $scope.defaultTime = moment(new Date("2018-07-09T13:01:34.103Z"));


            $scope.ok = function () {
                $uibModalInstance.close();
            };

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };


        }]);

})(window.angular);
